import * as Yup from "yup";
import { useState } from "react";
import { useGetGymlistQuery ,useGetGymlistallQuery} from "../../../store/api/account";
import { usePostPlanMutation } from "../../../store/api/adminplan";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";

const AdminplanCreate = () => {
  const navigate = useNavigate();
  const { data: tabledata } = useGetGymlistallQuery();
  const [postPlan] = usePostPlanMutation();
  const [feedbackMessage, setFeedbackMessage] = useState({
    type: "",
    message: "",
  });
  
 console.log(tabledata,"tableDAta");
 
  const gymOptions = tabledata?tabledata.map((gym) => ({ value: gym.id, label: gym.gym_name }))
    : []; 
  const initialValues = {
    selectedGym: "",
    planType: "",
    planDuration: "",
    planEndDate: "",
    planSlabs: [{ minMember: "", maxMember: "", slabAmount: "" }],
  };
  const validationSchema = Yup.object().shape({
    selectedGym: Yup.string().required("Gym selection is required"),
    planType: Yup.string()
      .oneOf(["POSTPAID", "PREPAID"], "Invalid plan type")
      .required("Plan type is required"),
    planDuration: Yup.string()
      .oneOf(["MONTHLY", "QUARTLY", "HALFYEARLY", "YEARLY"], "Invalid duration")
      .required("Plan duration is required"),
    planEndDate: Yup.date()
      .nullable()
      .required("Plan end date is required")
      .min(new Date(), "Plan end date must be in the future"),
    planSlabs: Yup.array().of(
      Yup.object().shape({
        minMember: Yup.number().typeError("Must be a number").positive("Min Member must be a positive number").required("Min Member is required"),
        maxMember: Yup.number().typeError("Must be a number").positive("Max Member must be a positive number").required("Max Member is required"),
        slabAmount: Yup.number().typeError("Must be a number").positive("Slab Amount must be a positive number").required("Slab Amount is required"),
      })
    ),
  });
  const handleSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      const formattedData = {
        plan_name: gymOptions.find((gym) => gym.value === Number(values.selectedGym))?.label || "",
        domain: Number(values.selectedGym),
        plan_end_date: values.planEndDate ? new Date(values.planEndDate).toISOString() : null,
        plan_type: values.planType,
        plan_duration_type: values.planDuration,
        plan_slab: values.planSlabs.map((slab) => ({
          min_member: Number(slab.minMember),
          max_member: Number(slab.maxMember),
          slab_amount: Number(slab.slabAmount),
        })),
      };

      const response = await postPlan(formattedData).unwrap();
      if (response.status === 201) {
        setFeedbackMessage({ message: "Admin Plan created Successfully", type: "success" });
        setTimeout(() => navigate("/adminplan-list",{ state: { pageName: "AdminPlan" } }), 2000);
      }
    } catch (error) {
      setFeedbackMessage({ message: error.data?.error || "Something went wrong", type: "error" });
    }
    setSubmitting(false);
  };
  return (
    <div className="w-full rounded-xl mt-2  mx-auto py-1">
      <div className="py-4 bg-white rounded-lg shadow px-3">
        <h2 className=" py-3 px-4 font-inter text-2xl text-[#333843] font-semibold">Add Admin Plan</h2>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, handleBlur, setFieldValue, isSubmitting, status }) => (
            <Form className="grid grid-cols-2 gap-4 mx-4 mb-4 mt-3">
              <div>
                <label className="block text-sm font-medium text-black-700">Gym Name <span className="text-red-500">*</span></label>
                <Field as="select" name="selectedGym" className="w-full p-2 border rounded-lg">
                  <option value="">Select a Gym</option>
                  {gymOptions.map((gym) => (
                    <option key={gym.value} value={gym.value}>
                      {gym.label}
                    </option>
                  ))}
                </Field>
                <ErrorMessage name="selectedGym" component="div" className="text-red-500 text-sm" />
              </div>
              <div className="mx-2">
                <label className="block text-sm font-medium text-black-700">Plan Type <span className="text-red-500">*</span></label>
                <Field as="select" name="planType" className="w-full px-4 py-2 border rounded-lg">
                  <option value="">Select Plan-Type</option>
                  <option value="POSTPAID">POSTPAID</option>
                  <option value="PREPAID">PREPAID</option>
                </Field>
                <ErrorMessage name="planType" component="div" className="text-red-500 text-sm" />
              </div>
              <div className="gap-4">
                <label className="block text-sm font-medium text-black-700">Plan Duration <span className="text-red-500">*</span></label>
                <Field as="select" name="planDuration" className="w-full px-4 py-2 border rounded-lg">
                  <option value="">Select Duration</option>
                  <option value="MONTHLY">MONTHLY</option>
                  <option value="QUARTLY">QUARTLY</option>
                  <option value="HALFYEARLY">HALFYEARLY</option>
                  <option value="YEARLY">YEARLY</option>
                </Field>
                <ErrorMessage name="planDuration" component="div" className="text-red-500 text-sm" />
              </div>
              <div className="mx-2">
                <label className="block text-sm font-medium text-black-700">Plan End Date  <span className="text-red-500">*</span></label>
                <Field
                  type="date"
                  name="planEndDate"
                  className="w-full p-2 border rounded-lg"
                />
                <ErrorMessage name="planEndDate" component="div" className="text-red-500 text-sm" />
              </div>
              <div className="col-span-2 mt-3">
                {values.planSlabs.map((slab, index) => (
                  <div key={index} className="flex space-x-3 mb-3">
                    <div className="w-1/3">
                      <Field type="number" name={`planSlabs[${index}].minMember`} placeholder="Min Member" className="w-full p-2 border rounded-lg" />
                      <ErrorMessage name={`planSlabs[${index}].minMember`} component="div" className="text-red-500 text-sm" />
                    </div>
                    <div className="w-1/3">
                      <Field type="number" name={`planSlabs[${index}].maxMember`} placeholder="Max Member" className="w-full p-2 border rounded-lg" />
                      <ErrorMessage name={`planSlabs[${index}].maxMember`} component="div" className="text-red-500 text-sm" />
                    </div>
                    <div className="w-1/3">
                      <Field type="number" name={`planSlabs[${index}].slabAmount`} placeholder="Slab Amount" className="w-full p-2 border rounded-lg" />
                      <ErrorMessage name={`planSlabs[${index}].slabAmount`} component="div" className="text-red-500 text-sm" />
                    </div>
                    <button
                      type="button"
                      onClick={() => setFieldValue("planSlabs", values.planSlabs.filter((_, i) => i !== index))}
                      className="px-4 py-2 bg-gray-300 rounded-lg "
                    >
                      Delete
                    </button>
                  </div>
                ))}
                <button type="button" onClick={() => setFieldValue("planSlabs", [...values.planSlabs, { minMember: "", maxMember: "", slabAmount: "" }])}
                  className="px-4 py-2 bg-secondary text-white rounded-lg">
                  Add Slab

                </button>
              </div>
      
              {feedbackMessage?.type && (
                <div
                  className={`col-span-2 w-full mt-3 rounded-lg px-4 py-3 text-md font-medium border 
      ${feedbackMessage.type === "success" ? "bg-green-100 text-green-700 border-green-300"
                      : "bg-red-100 text-red-700 border-red-300"}`}
                  role="alert"
                >
                  {feedbackMessage.message}
                </div>
              )}


              <div className="flex justify-end col-span-2 space-x-4 mt-6">

                <button type="reset" className="px-4 py-2 bg-gray-300 rounded-lg " onClick={() => { navigate("/adminplan-list",{ state: { pageName: "AdminPlan" }}); }} >
                  cancel
                </button>
                <button type="submit" disabled={isSubmitting} className="px-4 py-2 bg-secondary text-white rounded-lg">
                  {isSubmitting ? "Submitting..." : "Add Plan"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AdminplanCreate;
